import { gql } from "@apollo/client";

export const CrmMappingRequestInputTypeDef = gql`
  input CrmMappingRequestInput {
    crmBrandStatus: String!
    crmInnerStatus: String!
  }
`;

export const BrandBridgeParameterRequestInputTypeDef = gql`
  input BrandBridgeParameterRequestInput {
    parameterValue: String!
    parameterId: Int!
  }
`;

export const ApiIntegrationCreateRequestInputTypeDef = gql`
  input ApiIntegrationCreateRequestInput {
    bridgeId: Int!
    baseGetDepositorsUrl: String!
    baseGetRegistrationsUrl: String!
    baseSendRegistrationUrl: String!
    brandBridgeParameters: [BrandBridgeParameterRequestInput!]!
    crmMappings: [CrmMappingRequestInput!]
  }
`;

export const LinkS2SRequestInputTypeDef = gql`
  input LinkS2SRequestInput {
    landingParam: String
    landingValue: String
    link: String!
    subParam1Name: String
    subParam1Value: String
    subParam2Name: String
    subParam2Value: String
  }
`;

export const S2SIntegrationCreateRequestInputTypeDef = gql`
  input S2SIntegrationRequestInput {
    id: Long
    clickId: String!
    tenantId: String
    name: String!
    mpc_1: String
    mpc_2: String
    mpc_3: String
    mpc_4: String
    links: [LinkS2SRequestInput]
  }
`;

export const LinkS2SRequestUpdateInputTypeDef = gql`
  input S2SLinksUpsertRequestInput {
    id: Long
    landingParam: String
    landingValue: String
    link: String!
    subParam1Name: String
    subParam1Value: String
    subParam2Name: String
    subParam2Value: String
  }
`;

export const S2SIntegrationUpdateRequestInputTypeDef = gql`
  input S2SIntegrationUpsertRequestInput {
    clickId: String!
    id: Long
    tenantId: String
    name: String!
    mpc_1: String
    mpc_2: String
    mpc_3: String
    mpc_4: String
    links: [S2SLinksUpsertRequestInput!]!
  }
`;

export const BrandStatusInputTypeDef = gql`
  enum BrandStatus {
    Active
    Blocked
  }
`;

export const UserStatusInputTypeDef = gql`
  enum userStatus {
    Active
    Blocked
  }
`;
